<div class="ontario-row">
  @if (enrolmentDto) {
    <div class="training-schedule-div ontario-column ontario-small-12">
      <div class="ontario-small-12">
        <app-alert-banner bannerType="warning" [bannerText]="translateService.instant('ClassEnrolment.WorkerEnrolmentNotConfirmed')"></app-alert-banner>
      </div>
      <div class="alert-box-container ontario-small-12">
        <app-alert-banner bannerType="success" [bannerText]="translateService.instant('ClassEnrolment.WorkerEnrolmentRequestSent').replace('{0}',enrolmentDto.ProgramName).replace('{1}',enrolmentDto.TrainingProviderName).replace('{2}',enrolmentDto.EmailAddress)">
        </app-alert-banner>
      </div>
      <div class="field ontario-small-12 ontario-large-4">
        <mat-label class="input-label">
          <span>{{"ClassEnrolment.EnrolmentRequestType" | translate}}</span>
        </mat-label>
        @if (isPreviewMode) {
          <label class="answer-text">{{enrolmentRequestType}}</label>
        }
      </div>
      <div class="field ontario-small-12 ontario-large-4">
        <mat-label class="input-label">
          <span>{{'ClassEnrolment.EnrolmentRequestFor' | translate}}</span>
        </mat-label>
        @if (isPreviewMode) {
          <label class="answer-text">{{enrolmentRequestFor}}</label>
        }
      </div>
      <div class="ontario-margin-top-48-! ontario-small-12 ontario-large-12 ontario-medium-12">
        <h3 class="border-bottom">
          {{'ClassEnrolment.LearnerDetails' | translate}}
        </h3>
      </div>
      <!--single learner info start -->
      <div class="content">
        <div class="field ontario-small-12 ontario-large-4">
          <mat-label class="input-label">
            <span class="required-field">{{'ClassEnrolment.EmailAddress' | translate}}</span>
          </mat-label>
          @if (isPreviewMode) {
            <label class="answer-text">{{enrolmentDto.EmailAddress}}</label>
          }
        </div>
        <div class="field ontario-small-12 ontario-large-4">
          <mat-label class="input-label">
            <span class="required-field">{{'Contact.FirstName' | translate}}</span>
          </mat-label>
          @if (isPreviewMode) {
            <label class="answer-text">{{enrolmentDto.FirstName}}</label>
          }
        </div>
        <div class="field ontario-small-12 ontario-large-4">
          <mat-label class="input-label">
            <span class="required-field">{{'Contact.LastName' | translate}}</span>
          </mat-label>
          @if (isPreviewMode) {
            <label class="answer-text">{{enrolmentDto.LastName}}</label>
          }
        </div>
        <div class="field ontario-small-12 ontario-large-4">
          <mat-label class="input-label">
            <span class="required-field">{{'ClassEnrolment.Phone' | translate}}</span>
            <app-tooltip [tooltipText]="'ClassEnrolment.PhoneIconTooltip' | translate"></app-tooltip>
          </mat-label>
          @if (isPreviewMode) {
            <label class="answer-text">{{enrolmentDto.Phone | phone}}</label>
          }
        </div>
        <div class="field ontario-small-12 ontario-large-4">
          <mat-label class="input-label">
            {{'ClassEnrolment.BirthYear' | translate}}
            <app-tooltip [tooltipText]="'ClassEnrolment.BirthYear' | translate">
            </app-tooltip>
          </mat-label>
          @if (isPreviewMode) {
            <label class="answer-text">{{enrolmentDto.BirthYear}}</label>
          }
        </div>
        <div class="field ontario-small-12 ontario-large-6">
          <div class="message-box">
            <mat-label class="input-label">
              <span>{{'ClassEnrolment.Note' | translate}}</span>
            </mat-label>
            @if (isPreviewMode) {
              <label class="answer-text">{{enrolmentDto.NoteToProvider}}</label>
            }
          </div>
        </div>
        <div class="enrolment-confirmation-box ontario-small-12">
          <div class="heading">
            <h4 class="border-bottom ontario-margin-bottom-24-!">
              {{'ClassEnrolment.Subscription' | translate}}
            </h4>
          </div>
          <div class="ontario-margin-bottom-12-! flex-container">
            <div class="checkbox-value">{{(enrolmentDto.OptInForEmail === true ? 'General.Yes' : 'General.No') | translate }}</div>
            <div>{{'ClassEnrolment.OptInForEmail' | translate}}</div>
          </div>
          <div class="ontario-margin-bottom-12-! flex-container">
            <div class="checkbox-value">{{(enrolmentDto.OptInForText === true ? 'General.Yes' : 'General.No') | translate }}</div>
            <div>{{'ClassEnrolment.OptInForText' | translate}}</div>
          </div>
          <div class="field ontario-small-12">
            <mat-label class="input-label">
              {{'ClassEnrolment.SubmittedOn' | translate}}
            </mat-label>
            @if (isPreviewMode) {
              <label class="answer-text">{{enrolmentDto.CreatedDate | utcToLocalDateTime:'medium'}}</label>
            }
          </div>
        </div>
      </div>
      <!--single learner info end-->
      <div class="horizontal-rule-no-margin  ontario-small-12 ontario-large-12 ontario-medium-12">
      </div>
      <div class="border-bottom-end">
      </div>
    </div>
  }
</div>
